<dsd-alert full-width dynamic variant="information">
  {{ 'notifications.preautorisation-dsd' | translate }}
</dsd-alert>
